import type {
  TaxCodeFilterOptionsQueryParams,
  TaxCodeFilterOptionsResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodTaxCodeFilterOptionsQueryParamsSchema,
  zodTaxCodeFilterOptionsResponseSchema,
} from './validations';

/**
 * Fetches distinct tax-code values available to list filters.
 *
 * @param queryParams - Company filters that scope the available values.
 * @param options - Additional request options.
 * @returns Available tax-code names, rates, and codes.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const fetchTaxCodeFilterOptions = async (
  queryParams: Partial<TaxCodeFilterOptionsQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.TAX_CODE.FILTER_OPTIONS(), {
      searchParams: withoutObjectKeysWhereValueIs(queryParams, [
        undefined,
        '',
      ]) as Record<string, string | undefined>,
      ...options,
      validate: {
        ...options?.validate,
        response: zodTaxCodeFilterOptionsResponseSchema,
        searchParams: zodTaxCodeFilterOptionsQueryParamsSchema,
      },
    })
    .json<TaxCodeFilterOptionsResponse>();
